import axios from 'axios'

export default {
  async HOME_PAGE ({ state, commit }) {
    const { data } = await axios.get(state.api + '/api')
    commit('nav', data)
    commit('contacts', data)
    commit('department', data)
    commit('homeNews', data)
    commit('homeGallery', data)
    commit('homeDocuments', data)
    commit('homeStatistics', data)
    commit('links', data)
    commit('slider', data)
  },
  async NEWS_PAGE ({ state, commit }, next) {
    if (next) {
      const { data } = await axios.get(state.news.next_page_url)
      commit('nav', data)
      commit('contacts', data)
      commit('news', {
        next,
        data
      })
      commit('department', data)
    } else {
      const { data } = await axios.get(state.api + '/api/news')
      commit('nav', data)
      commit('contacts', data)
      commit('news', {
        next,
        data
      })
      commit('department', data)
    }
  },
  async GALLERY_PAGE ({ state, commit }, next) {
    if (next) {
      const { data } = await axios.get(state.gallery.next_page_url)
      commit('nav', data)
      commit('contacts', data)
      commit('gallery', {
        next,
        data
      })
      commit('department', data)
    } else {
      const { data } = await axios.get(state.api + '/api/gallery')
      commit('nav', data)
      commit('contacts', data)
      commit('gallery', {
        next,
        data
      })
      commit('department', data)
    }
  },
  async ARTICLE_PAGE ({ state, commit }, id) {
    const { data } = await axios.get(state.api + '/api/news/' + id)
    commit('nav', data)
    commit('contacts', data)
    commit('article', data)
  },
  async PHOTOS_PAGE ({ state, commit }, id) {
    const { data } = await axios.get(state.api + '/api/gallery/' + id)
    commit('nav', data)
    commit('contacts', data)
    commit('photos', data)
  },
  async DOCUMENTS_PAGE ({ state, commit }, id) {
    const { data } = await axios.get(state.api + '/api/documents')
    commit('nav', data)
    commit('contacts', data)
    commit('categories', data)
  },
  async DOCUMENTS_OPEN_PAGE ({ state, commit }, id) {
    const { data } = await axios.get(state.api + '/api/documents/' + id)
    commit('nav', data)
    commit('contacts', data)
    commit('documents', data)
    commit('categories', data)
  },
  async DOCUMENTS_SHOW_PAGE ({ state, commit }, { catId, id }) {
    const { data } = await axios.get(state.api + '/api/documents/' + catId + '/' + id)
    commit('nav', data)
    commit('contacts', data)
    commit('document', data)
    commit('categories', data)
  },
  async MANAGEMENTS_PAGE ({ state, commit }) {
    const { data } = await axios.get(state.api + '/api/managements')
    commit('nav', data)
    commit('contacts', data)
    commit('managements', data)
  },
  async INSTITUTIONS_PAGE ({ state, commit }) {
    const { data } = await axios.get(state.api + '/api/institutions')
    commit('nav', data)
    commit('contacts', data)
    commit('institutions', data)
  },
  async PARTITIONS_PAGE ({ state, commit }) {
    const { data } = await axios.get(state.api + '/api/partitions')
    commit('nav', data)
    commit('contacts', data)
    commit('partitions', data)
  },
  async PARTITIONS_OPEN_PAGE ({ state, commit }, id) {
    const { data } = await axios.get(state.api + '/api/partition/' + id)
    commit('nav', data)
    commit('contacts', data)
    commit('materials', data)
  },
  async PARTITIONS_SHOW_PAGE ({ state, commit }, id) {
    const { data } = await axios.get(state.api + '/api/material/' + id)
    commit('nav', data)
    commit('contacts', data)
    commit('material', data)
  },
  async APPLY_PAGE ({ state, commit }) {
    const { data } = await axios.get(state.api + '/api')
    commit('nav', data)
    commit('contacts', data)
    commit('appeals', data)
  }
}
